(function ($, Drupal, once) {
    Drupal.behaviors.mo50 = {
        attach() {
            $(once('mo50', 'body')).each(function () {
                $(document).on('click', '.MO50', function () {
                    const $eventBlock = $(this).closest('.MO50');
                    const $eventCard = $('.MO50__card', $eventBlock);
                    const $eventContent = $('.MO50__card-inner', $eventBlock);
                    if ($eventContent) {
                        gsap.to($eventContent, {
                            opacity: 0,
                            y: '20px',
                            duration: 0.2,
                            onComplete: () => {
                                $eventBlock.toggleClass('expanded');
                                $eventCard.toggleClass('expanded');
                                gsap.to($eventContent, {
                                    opacity: 1,
                                    delay: 0.35,
                                    y: 0,
                                    duration: 0.35
                                });
                            }
                        });
                    }
                });
            });
        },
    };
})(jQuery, Drupal, once);
